import React from 'react';
import { Typography, Box, Paper } from '@mui/material';

import ButtonTextHide from '../SubComponents/ButtonTextHide';

const Guia = ({ handleChangeOption }) => {

  return (
    <>
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="flex-start"
      height="100%"
      textAlign="center"
    >
      <Typography 
      variant="h1" 
      gutterBottom       
      sx={{
        fontSize: {
          xs: '2rem',   // Para pantallas pequeñas (xs)
          sm: '3rem',   // Para pantallas medianas (sm)
          md: '4rem',   // Para pantallas grandes (md)
          lg: '5rem',   // Para pantallas más grandes (lg)
        },
        textAlign: 'center',
      }}
      >
        ¡Hola!
      </Typography>
      <Typography variant="h6" color='grey.500'>
        Esta es la guía de la página web, en la cual aprenderás cómo usarla y qué hacer.
      </Typography>

      <Paper 
        elevation={3} 
        sx={{
          padding: 2, 
          display: 'flex', 
          flexDirection: 'column', 
          gap: 2, 
          backgroundColor: theme => theme.palette.mode === 'dark' ? 'black' : 'white',
          marginTop: 3,
        }}
      >
        <ButtonTextHide 
          handleChangeOption={handleChangeOption}
          buttonText={'¿Qué es la campanita?'} 
          hideText={'La campanita de abajo a la izquierda sirve para ver las notificaciones de las Mensualidades, especificamente si ya están por terminar'} 
          justInfo={true}
        />
        <ButtonTextHide 
          handleChangeOption={handleChangeOption}
          buttonText={'Vehiculos'} 
          hideText={'Acá podras registrar la entrada y salida de vehiculos y también ver los vehiculos anteriormente registrados (y obviamente crear nuevos vehiculos para poder marcarlos como que salieron o entraron si no los encuentras ya creados en la tabla de vehiculos), osea tienes 3 apartados, entrada, salida y vehiculos, usaras entrada cuando entre algún vehiculo, salida cuando salga y en vehiculos podras ver los vehiculos posibles'} 
          justInfo={false}
        />
        <ButtonTextHide 
          handleChangeOption={handleChangeOption}
          buttonText={'Clientes'} 
          hideText={'Acá podras ver todos los clientes registrados'}  
          justInfo={false}
        />
        <ButtonTextHide 
          handleChangeOption={handleChangeOption}
          buttonText={'Estadias'} 
          hideText={'Acá podras ver todas las estancias de los vehiculos y cuanto duraron o si aún no se han marcado como que han salido del parqueadero, acá no podras modificar nada, sólo ver, las instancias se crean al marcar la entrada de un vehiculo y se marcan como finalizadas al marcar la salida del mismo'}  
          justInfo={false}
        />
        <ButtonTextHide  // las estadias pueden ser modificadas por los admins solamente o tmb por los empleados
          handleChangeOption={handleChangeOption}
          buttonText={'Tarifas'} 
          hideText={'Acá podras ver y modificar los precios de las estadias y mirar que tipo hay y cuanto cuesta'}  
          justInfo={false}
        />
        <ButtonTextHide  // explicar mejor
          handleChangeOption={handleChangeOption}
          buttonText={'Mensualidades'} 
          hideText={'Acá podras ver las mensualidades que faltan terminar y todas las mensualidades que hay, cuanto duraron o cuando terminaran y esas cosas'}  
          justInfo={false}
        />
        <ButtonTextHide  // no entiendo pa que funciona o q se hace
          handleChangeOption={handleChangeOption}
          buttonText={'Caja'} 
          hideText={'La cantidad de dinero que entra al parqueadero, estos son en forma de movimiento. Representa tu turno como empleado.'}  
          justInfo={false}
        />
        <ButtonTextHide  // en la página no muestra nada
          handleChangeOption={handleChangeOption}
          buttonText={'Usuarios'} 
          hideText={'Muestra a todos los usuarios que hay y qué rango tienen (En el modo admin puedes cambiarlos)'}  
          justInfo={false}
        />
        <ButtonTextHide  // No entiendo pa q sirve
          handleChangeOption={handleChangeOption}
          buttonText={'Reportes'} 
          hideText={'Estadisticas generales con graficas.'}  
          justInfo={false}
        />
        {/* Puedes añadir más ButtonTextHide aquí */}

        <Typography variant="h6" color='grey.500'>
          Esperamos haberte ayudado ☻
        </Typography>
      </Paper>

    </Box>
    </>
  );
};

export default Guia;

// agregar resaltado en palabras